import cloneDeep from "lodash/cloneDeep";

import parseOcrolusCffDataWorkerUrl from "@/workers/services/ocrolusCffDataWorker?worker&url";

import type {
  CashFlowFeaturesData,
  CffDataBlock,
} from "@/models/commercialData/Ocrolus";

export const getDataBlocks = (
  features: CashFlowFeaturesData["cash_flow_features"] | undefined
) => {
  const parseDataServicesWorker = new Worker(parseOcrolusCffDataWorkerUrl, {
    type: "module",
  });

  return new Promise<CffDataBlock[]>((resolve) => {
    parseDataServicesWorker.onmessage = (event: MessageEvent) => {
      resolve(event.data);
      parseDataServicesWorker.terminate();
    };

    parseDataServicesWorker.postMessage(cloneDeep(features));
  });
};

export const isOcrolusFullResponseAttribute = <T>(attributeResult: T) => {
  const ocrolusKeys = ["book_pk", "book_id", "book_uuid"] as const;

  return (
    typeof attributeResult === "object" &&
    attributeResult !== null &&
    !Array.isArray(attributeResult) &&
    ocrolusKeys.some((key) => key in attributeResult)
  );
};
